// extracted by mini-css-extract-plugin
module.exports = {"default":"Brand_default__jriME","white":"Brand_white__MXPYV Brand_default__jriME","large":"Brand_large__c9hmX Brand_default__jriME"};